import FormattedMessageWithObjectTypeName from 'automation-ui-i18n/FormattedMessageWithObjectTypeName';
import UICheckbox from 'UIComponents/input/UICheckbox';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { useTrackEvent } from 'automation-ui-usage-tracking/usageTrackingHooks';
import Trackables from 'automation-ui-usage-tracking/Trackables';
import { ILS_GOALS_MIGRATION } from 'automation-ui-canvas/constants/Gates';
import { useIsUngated } from 'automation-ui-core/hooks/authHooks';
import { useCallback } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const ListeningControl = ({
  isListeningSettingDisabled,
  flow,
  classicEnrollmentSettings,
  readOnly,
  enrollmentList,
  onChange
}) => {
  var _enrollmentList$value;
  const trackEvent = useTrackEvent();
  const isUngatedForIlsGoals = useIsUngated(ILS_GOALS_MIGRATION);
  const isListeningILS = enrollmentList === null || enrollmentList === void 0 || (_enrollmentList$value = enrollmentList.value) === null || _enrollmentList$value === void 0 ? void 0 : _enrollmentList$value.listTypes.includes('SUPPRESSION_REMOVE_LIST');
  const isChecked = isUngatedForIlsGoals ? isListeningILS : classicEnrollmentSettings === null || classicEnrollmentSettings === void 0 ? void 0 : classicEnrollmentSettings.listening;
  const hasEnrollmentList = isListeningSettingDisabled ? isListeningSettingDisabled.value : flow.enrollmentTrigger === 'LIST' && flow.associatedLists.some(list => list.listTypes.includes('ENROLLMENT_LIST'));
  const handleOnChange = useCallback(({
    checked
  }) => {
    const currentList = enrollmentList && enrollmentList.value;
    if (isUngatedForIlsGoals && currentList) {
      onChange({
        enrollmentList: {
          value: Object.assign({}, currentList, {
            listTypes: checked ? ['ENROLLMENT_LIST', 'SUPPRESSION_REMOVE_LIST'] : ['ENROLLMENT_LIST']
          })
        }
      });
    } else {
      onChange({
        classicEnrollmentSettings: classicEnrollmentSettings === null || classicEnrollmentSettings === void 0 ? void 0 : classicEnrollmentSettings.set('listening', checked)
      });
    }
  }, [classicEnrollmentSettings, enrollmentList, isUngatedForIlsGoals, onChange]);
  return /*#__PURE__*/_jsx(UITooltip, {
    title: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "settings.listeningSetting.listBasedFlows.disabledTooltip"
    }),
    placement: "left",
    disabled: !hasEnrollmentList,
    children: /*#__PURE__*/_jsx(UICheckbox, {
      size: "small",
      readOnly: readOnly,
      disabled: hasEnrollmentList,
      checked: isChecked !== null && isChecked !== void 0 ? isChecked : undefined,
      onChange: ({
        target: {
          checked
        }
      }) => {
        trackEvent(Trackables.WORKFLOW_SETTINGS_INTERACTION, {
          value: `${checked}`,
          subAction: 'listening'
        });
        handleOnChange({
          checked
        });
      },
      children: /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
        baseLangKey: "settingsV2.enrollmentNotificationSetting.classicUnenrollment.criteria_cob",
        objectTypeId: flow.objectTypeId
      })
    })
  });
};
export default ListeningControl;